import { select } from 'redux-most';
import { switchMap, waitUntil, ignoreElements } from 'most-adjunct';
import * as r from 'ramda';
import * as signals from '../../signals';
import {
  shouldShowConsent,
  shouldSendEvent,
  getDomain,
} from '../../../domain/selectors';

export default function createBootstrapEpic(
  sendAnalytics,
) {
  return (actions, store) => r.pipe(
    select(signals.BOOTSTRAP),
    switchMap(() => {
      return waitUntil(() => window.utag != null).map(() => {
        const state = store.getState();
        const showConsent = shouldShowConsent(state);
        const domain = getDomain(state);

        if(showConsent === true) {

          if(shouldSendEvent(state) === true) {
            sendAnalytics({
              ec: 'Impression',
              ea: 'ribbon', // currently we only have the ribbon version of upm
              dh: domain,
            });
          }
        }
      });
    }),
    ignoreElements,
  )(actions);
}
